import httpClient from '@/lib/httpClient.js'
import { useQuery } from '@tanstack/react-query'
import useModelsFingerprint from '@/services/api/model/useModelsFingerprint'

/**
 * GET team/cash-flow/forecast-score/insights — "same period, earlier years"
 * signals for the month currently open.
 *
 * Distinct from the trailing-window forecast insights (BE 17) that back
 * "Where you came up short" — this one compares against the same calendar
 * month in earlier years.
 */
export default function useGetSeasonalInsights({
  limit = 3,
  enabled = true,
} = {}) {
  const modelsFingerprint = useModelsFingerprint()

  const fetchData = async () => {
    const response = await httpClient.get(
      'team/cash-flow/forecast-score/insights',
      {
        params: { limit },
      },
    )
    return response.data
  }

  return useQuery({
    queryKey: ['seasonal-insights', { limit, modelsFingerprint }],
    queryFn: fetchData,
    staleTime: Infinity,
    enabled,
  })
}
